/**
 * FocusHook - Automatically focuses an input element when it's mounted
 * 
 * Usage: Add phx-hook="FocusHook" to any input element
 */
const FocusHook = {
  mounted() {    
    this.el.focus()
    this.el.select()
  },

  updated() {
    // useful for re-rendering the input
    this.el.focus()
    this.el.select()
  }
}

export default FocusHook
